import Api, { configFormData } from "@/config/Api";

export default {
  getQuotes(options = {}) {
    return Api().get(`/quotes`, options);
  },

  getClientQuotes(clientId, options = {}) {
    return Api().get(`/quotes?client=${clientId}`, options);
  },

  getQuoteId(quoteId) {
    return Api().get(`/quotes/${quoteId}`);
  },

  getTimeline(quoteId) {
    return Api().get(`/quotes/${quoteId}/timeline`);
  },

  addQuotes(data) {
    return Api().post("/quotes", data);
  },

  updateQuoteId(quoteId, data) {
    return Api().put(`/quotes/${quoteId}`, data);
  },

  deleteQuoteId(quoteId) {
    return Api().delete(`/quotes/${quoteId}`, {});
  },

  updateQuoteStatus(quoteId, data) {
    return Api().put(`/status/quotes/${quoteId}`, data);
  },

  updateReminders(quoteId, { enable_reminders }) {
    const endpoint = enable_reminders
      ? "/reminders/resume"
      : "/reminders/pause";
    return Api().post(endpoint, {
      document_type: "quote",
      document_id: quoteId
    });
  },

  sendQuoteEmail({ data }) {
    return Api().post(`/send/quotes`, data, configFormData);
  },

  sendQuoteToInvoice(data) {
    return Api().post(`/quotes/to/invoice`, data);
  },

  getInstallments(quoteId, versionId) {
    return Api().get(`/quotes/${quoteId}/versions/${versionId}/installments`);
  },

  syncInstallments(quoteId, versionId, installments) {
    return Api().post(
      `/quotes/${quoteId}/versions/${versionId}/installments/sync`,
      { installments }
    );
  },

  downloadQuote(data) {
    return Api().get(
      `/download/quotes?quote_id=${data.quoteId}&quote_version_id=${data.quoteVersionId}`,
      { responseType: "arraybuffer" }
    );
  },

  // ════════ Métodos Batch (Optimizados para acciones masivas) ════════
  /**
   * Actualizar estado de múltiples cotizaciones en un lote
   * @param {Array} quoteIds - Array de IDs
   * @param {Object} statusData - Datos de estado a actualizar
   */
  updateQuoteStatusBatch(quoteIds, statusData) {
    return Api().post(`/status/quotes`, {
      quote_ids: quoteIds,
      ...statusData
    });
  }
};
